import { addMaterialRow, addMachineRow } from "./rows.js";
import { calculateTotals } from "./totals.js";
import { validateMaterialsBeforeSubmit } from "./validation.js";

export function bindEvents(form, materialsContainer, machinesContainer, materialOptions, materialMap, machineOptions) {
  document.getElementById("addMaterialBtn").addEventListener("click", () => {
    const index = materialsContainer.children.length;
    addMaterialRow(index, materialOptions, materialMap, materialsContainer);
  });

  document.getElementById("addMachineBtn").addEventListener("click", () => {
    const index = machinesContainer.children.length;
    addMachineRow(index, machineOptions, machinesContainer);
  });

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("removeRowBtn")) {
      e.target.closest(".row").remove();
      calculateTotals(materialsContainer);
    }
  });

  form.addEventListener("input", () => calculateTotals(materialsContainer));

  // 🔒 Supplier validation before submission
  form.addEventListener("submit", (e) => {
    if (!validateMaterialsBeforeSubmit(materialsContainer)) {
      e.preventDefault(); // block submission
    }
  });
}
